/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Alert_LoadingInputs */

const en_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending message...`)
};

const ar_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ إرسال الرسالة...`)
};

const bn_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা পাঠানো হচ্ছে...`)
};

const de_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht wird gesendet...`)
};

const es_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando mensaje...`)
};

const fr_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi du message...`)
};

const pt_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando mensagem...`)
};

const zh_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在发送消息...`)
};

const tr_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönderiliyor...`)
};

const ru_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка сообщения...`)
};

const pl_form_alert_loading = /** @type {(inputs: Form_Alert_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam wiadomość...`)
};

/**
* | output |
* | --- |
* | "Sending message..." |
*
* @param {Form_Alert_LoadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_alert_loading = /** @type {((inputs?: Form_Alert_LoadingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Alert_LoadingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_alert_loading(inputs)
	if (locale === "bn") return bn_form_alert_loading(inputs)
	if (locale === "de") return de_form_alert_loading(inputs)
	if (locale === "es") return es_form_alert_loading(inputs)
	if (locale === "fr") return fr_form_alert_loading(inputs)
	if (locale === "pt") return pt_form_alert_loading(inputs)
	if (locale === "zh") return zh_form_alert_loading(inputs)
	if (locale === "tr") return tr_form_alert_loading(inputs)
	if (locale === "ru") return ru_form_alert_loading(inputs)
	if (locale === "pl") return pl_form_alert_loading(inputs)
	return en_form_alert_loading(inputs)
});